import { FaXTwitter, FaDiscord } from "react-icons/fa6";
import { FaLinkedinIn, FaFacebookF, FaTelegramPlane } from "react-icons/fa";

const FooterPage = () => {
  return (
    <footer
      style={{
        background: "rgba(13,17,32,0.8)",
        borderTop: "1px solid rgba(255,255,255,0.05)",
      }}
    >
      <div className="max-w-7xl mx-auto px-8 py-16">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-10 mb-12">
          {/* Brand */}
          <div className="col-span-2 md:col-span-1">
            <div className="flex items-center gap-2 mb-4">
              <div
                className="w-7 h-7 rounded-lg flex items-center justify-center"
                style={{ background: "linear-gradient(135deg, #52c6a8, #4f8ef7)", boxShadow: "0 0 15px rgba(82,198,168,0.35)" }}
              >
                <span className="font-syne font-bold text-xs" style={{ color: "#06080f" }}>C</span>
              </div>
              <span className="font-syne font-bold text-white">CAHEX</span>
            </div>
            <p
              className="text-sm leading-relaxed"
              style={{ color: "var(--c-muted)", fontFamily: "'DM Sans', sans-serif", maxWidth: "200px" }}
            >
              The universal liquidity protocol for fiat and crypto interoperability.
            </p>
            <div className="flex gap-3 mt-5">
              {[FaXTwitter, FaLinkedinIn, FaDiscord, FaFacebookF, FaTelegramPlane].map((Icon, i) => (
                <button
                  key={i}
                  className="w-8 h-8 rounded-lg flex items-center justify-center transition-all duration-200"
                  style={{ background: "rgba(255,255,255,0.04)", border: "1px solid rgba(255,255,255,0.07)", color: "var(--c-muted)" }}
                  onMouseEnter={e => { e.currentTarget.style.borderColor = "rgba(82,198,168,0.4)"; e.currentTarget.style.color = "#52c6a8"; }}
                  onMouseLeave={e => { e.currentTarget.style.borderColor = "rgba(255,255,255,0.07)"; e.currentTarget.style.color = "var(--c-muted)"; }}
                >
                  <Icon size={13} />
                </button>
              ))}
            </div>
          </div>

          {/* Links */}
          {[
            { title: "Company", items: ["Cahex Finance", "Blog", "Medium", "Brand Kit", "Press Kit", "Support"] },
            { title: "Network", items: ["Products", "Use Cases", "Developers", "Learn", "Community"] },
            { title: "Legal", items: ["Terms & Conditions", "Airdrop Terms", "Privacy Policy"] },
          ].map(({ title, items }) => (
            <div key={title}>
              <div className="font-syne font-semibold text-white text-sm mb-4">{title}</div>
              <ul className="space-y-2.5">
                {items.map((item) => (
                  <li
                    key={item}
                    className="text-sm cursor-pointer transition-colors duration-150"
                    style={{ color: "var(--c-muted)", fontFamily: "'DM Sans', sans-serif" }}
                    onMouseEnter={e => { e.currentTarget.style.color = "#e8eaf0"; }}
                    onMouseLeave={e => { e.currentTarget.style.color = "var(--c-muted)"; }}
                  >
                    {item}
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="grad-divider mb-6" />

        <div
          className="flex flex-col md:flex-row justify-between items-center gap-3 text-xs"
          style={{ color: "var(--c-muted)", fontFamily: "'DM Sans', sans-serif" }}
        >
          <span>© 2024 CAHEX Network. All rights reserved.</span>
          <span
            className="font-mono-space"
            style={{ fontSize: "10px", color: "rgba(82,198,168,0.4)" }}
          >
            Universal Liquidity Protocol v1.0
          </span>
        </div>
      </div>
    </footer>
  );
};

export default FooterPage;
